import { themeGet } from '@styled-system/theme-get';
import { createGlobalStyle } from 'styled-components';

import exclamationWhite from '../images/exclamations-white.svg';
import exclamationRed from '../images/Exclamations.svg';
import ptsBubbleBlack from '../images/PTS-bubble-black.svg';
import ptsBubbleHolidayGreen from '../images/pts-bubble-holiday-green.svg';
import ptsBubbleHolidayRed from '../images/pts-bubble-holiday-red.svg';
import ptsBubbleRed from '../images/PTS-bubble-red.svg';
import ptsBubbleWhite from '../images/pts-bubble-white.svg';

import bladeStyles from './bladeStyles';
import cdicWidgetStyles from './cdicWidgetStyles';
import colorStyles from './colorStyles';
import infoWindowStyles from './infoWindowStyles';
import { toolTipStyles } from './toolTipStyles';
import typography from './typograph';
import variables from './variables';

const GlobalStyles = createGlobalStyle`
  /* Custom Global Styles */
  body.hide-ada #ada-entry{ 
    display:none;
    opacity:0;
  }

  #ada-entry{
    opacity: 1;
  }

  #ada-button-frame.hide-ada{
    display: none;
    opacity:0;
  }

  span.pts-bubble {
    display: inline;
    text-indent: -10000px;
    color: transparent;
    position: absolute;
    background-image: url(${ptsBubbleBlack});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    display: inline-block;
    height: auto;
    width: 30px;
    margin-left: 5px;

    @media only screen and (min-width: 480px) {
      height: 29px;
      width: 41px;
    }

    &.pc-red {
      background-image: url(${ptsBubbleRed});
    }
    &.holiday-red {
      background-image: url(${ptsBubbleHolidayRed});
    }
    &.holiday-green {
      background-image: url(${ptsBubbleHolidayGreen});
    }
    &.pc-points-day {
      background-image: url(${ptsBubbleWhite});
      &:before {
        content: '';
        display: block;
        background-image: url(${exclamationWhite});
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        position: absolute;
        height: 72px;
        width: 48px;
        right: 65%;
        bottom: 75%;
      }
    }
    &.holiday-green,
    &.holiday-red {
      margin-left: 0px;
      width: 35px;
      height: 20px;
      background-size: cover;
      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        width: 45px;
        height: 30px;
      }
      @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
        width: 65px;
        height: 40px;
      }
    }
    &.iol {
      display: none;
    }
  }

  .kampyle_button-text{
    background: #40404a !important;
  }

  &.exclamation {
    &:after {
      content: '';
      display: inline-block;
      background-image: url(${exclamationRed});
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      width: 1.75rem;
      height: 2.65rem;
      transform: rotate(-15.5deg);
    }
  }
  /* Custom Global Styles */


/* Reset box-model
   ========================================================================== */

* {
  box-sizing: border-box;
}

::before,
::after {
  box-sizing: inherit;
}

/* Reset ul list style bug
       ========================================================================== */

ul {
  &.no-bullets {
    margin: 0;
    list-style-type:none;
    list-style-image:none;

    li {
      list-style-type:none;
      list-style-image:none;
    }
  }

  li {
    list-style-image: none;
    list-style-type: disc;
  }
}

/* Document
       ========================================================================== */

/**
     * 1. Correct the line height in all browsers.
     * 2. Prevent adjustments of font size after orientation changes in iOS.
     * 3. Remove gray overlay on links for iOS.
     */

html {
  line-height: 1.15; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -webkit-tap-highlight-color: transparent; /* 3*/
  overflow-y: auto;
  /* scroll-behavior: smooth; */
}

/* Sections
       ========================================================================== */

/**
     * Remove the margin in all browsers.
     */

body {
  margin: 0;
  background-color: ${themeGet('colors.white')};
  font-family: ${themeGet('fonts.noir')};
  font-size: 1rem;
  line-height: 1.5rem;
  /* &.blade-is-open {
    overflow: hidden;
  } */
}

/**
     * Render the 'main' element consistently in IE.
     */

main {
  display: block;
}

/* Vertical rhythm
       ========================================================================== */

table,
blockquote,
address,
pre,
iframe,
form,
figure,
dl {
  margin: 0;
}

/* Headings
       ========================================================================== */

h1,
h2,
h3,
h4 {
  font-size: inherit;
  line-height: inherit;
  font-weight: inherit;
  margin: 0;

  sub, sup {
    font-size: 50%;
    top: -0.7em;
  }
}

/* Lists (enumeration)
       ========================================================================== */

ul,
ol {
  margin: 0;
  padding: 0;
  > li:not(:first-child) { 
    margin-top: 20px;
  }
  li {
    > p, span {
      display: inline;
    }
  }
}

ol {
  counter-reset: list-count;
  margin-bottom: 20px;
}

ul {
  margin-left: 20px;
}

ol {
  > li { 
    list-style-type:none;
    counter-increment: list-count;
  }
  > li:before { 
    font-weight: bold;
    content:counter(list-count) ".";
    margin-right: 8px;
  }
}

&.ordered-icon-list + p + ol, 
&.ordered-icon-list + ol, 
&.ordered-icon-list {
  > li {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  > li:before { 
    font-weight: ${({ theme }) => theme.fontWeights.medium};
    background-color: ${({ theme }) => theme.colors['border-grey']};
    border-radius: 50%;
    height: 40px;
    width: 40px;
    line-height: 40px;
    text-align: center;
    content: counter(list-count);
    margin-right: 8px;
  }
}

/* Lists (definition)
       ========================================================================== */

dt {
  font-weight: ${themeGet('fontWeights.bold')};
}

dd {
  margin-left: 0;
}

/* Grouping contentno 
       ========================================================================== */

/**
     * 1. Add the correct box sizing in Firefox.
     * 2. Show the overflow in Edge and IE.
     */

hr {
  box-sizing: content-box; /* 1 */
  height: 0; /* 1 */
  overflow: visible; /* 2 */
  border: 0;
  border-top: 1px solid;
  margin: 0;
  clear: both;
}

/**
     * 1. Correct the inheritance and scaling of font size in all browsers.
     * 2. Correct the odd 'em' font sizing in all browsers.
     */

pre {
  font-family: monospace, monospace; /* 1 */
  font-size: inherit; /* 2 */
}

address {
  font-style: inherit;
}

/* Text-level semantics
       ========================================================================== */

/**
     * Remove the gray background on active links in IE 10.
     */

a {
  background-color: transparent;
  text-decoration: none;
  color: inherit;
  /* outline: 0; */
}

/* Remove default margin from p tags */
p {
  margin: 0;
}

/* Hide empty element tags generated by contentful rich text editor */
h1:empty,
h2:empty,
h3:empty,
h4:empty,
h5:empty,
h6:empty, 
p:empty,
span:empty,
li:empty {
    display: none;
}

/**
     * 1. Remove the bottom border in Chrome 57-
     * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
     */

abbr[title] {
  border-bottom: none; /* 1 */
  text-decoration: underline; /* 2 */
  text-decoration: underline dotted; /* 2 */
}

/**
     * Add the correct font weight in Chrome, Edge, and Safari.
     */

b,
strong {
  font-weight: ${themeGet('fontWeights.medium')};
}

/**
     * 1. Correct the inheritance and scaling of font size in all browsers.
     * 2. Correct the odd 'em' font sizing in all browsers.
     */

code,
kbd,
samp {
  font-family: monospace, monospace; /* 1 */
  font-size: inherit; /* 2 */
}

/**
     * Add the correct font size in all browsers.
     */

small {
  font-size: 80%;
}

/**
     * Prevent 'sub' and 'sup' elements from affecting the line height in
     * all browsers.
     */

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/* Embedded content
       ========================================================================== */

/**
     * Remove the border on images inside links in IE 10.
     */

img {
  border-style: none;
  vertical-align: bottom;
}

embed,
object,
iframe {
  border: 0;
  vertical-align: bottom;
}

/* Forms
       ========================================================================== */

button,
input,
optgroup,
select,
textarea {
  vertical-align: middle;
  color: inherit;
  font: inherit;
  border: 0;
  background: transparent;
  padding: 0;
  margin: 0;
  /* outline: 0; */
}

/**
     * Remove all Style fro select elements. Does not quite work cross-browser
     */

select {
  -webkit-appearance: none;
  appearance: none;
  border-radius: 0;
}

/**
     * Show the overflow in IE.
     * 1. Show the overflow in Edge.
     */

button,
input {
  /* 1 */
  overflow: visible;
}

/**
     * Remove the inheritance of text transform in Edge, Firefox, and IE.
     * 1. Remove the inheritance of text transform in Firefox.
     */

button,
select {
  /* 1 */
  text-transform: none;
}

/**
     * Correct the inability to style clickable types in iOS and Safari.
     */

button,
[type='button'],
[type='reset'],
[type='submit'] {
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
}

button[disabled],
[type='button'][disabled],
[type='reset'][disabled],
[type='submit'][disabled] {
  cursor: default;
}

/**
     * Remove the inner border and padding in Firefox.
     */

button::-moz-focus-inner,
[type='button']::-moz-focus-inner,
[type='reset']::-moz-focus-inner,
[type='submit']::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/**
     * Restore the focus styles unset by the previous rule.
     */

button:-moz-focusring,
[type='button']:-moz-focusring,
[type='reset']:-moz-focusring,
[type='submit']:-moz-focusring {
  outline: 1px dotted ButtonText;
}

/**
     * Reset to invisible
     */

fieldset {
  margin: 0;
  padding: 0;
  border: 0;
  width: 100%;
  min-width: 0;
}

/**
     * 1. Correct the text wrapping in Edge and IE.
     * 2. Correct the color inheritance from 'fieldset' elements in IE.
     * 3. Remove the padding so developers are not caught out when they zero out
     *    'fieldset' elements in all browsers.
     */

legend {
  color: inherit; /* 2 */
  display: table; /* 1 */
  max-width: 100%; /* 1 */
  padding: 0; /* 3 */
  white-space: normal; /* 1 */
}

/**
     * Add the correct vertical alignment in Chrome, Firefox, and Opera.
     */

progress {
  vertical-align: baseline;
}

/**
     * Remove the default vertical scrollbar in IE 10+.
     */

textarea {
  overflow: auto;
}

/**
     * 1. Add the correct box sizing in IE 10.
     * 2. Remove the padding in IE 10.
     */

[type='checkbox'],
[type='radio'] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
}

/**
     * Correct the cursor style of increment and decrement buttons in Chrome.
     */

[type='number']::-webkit-inner-spin-button,
[type='number']::-webkit-outer-spin-button {
  height: auto;
}

/**
     * 1. Correct the odd appearance in Chrome and Safari.
     * 2. Correct the outline style in Safari.
     */

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/**
     * Remove the inner padding in Chrome and Safari on macOS.
     */

[type='search']::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
     * 1. Correct the inability to style clickable types in iOS and Safari.
     * 2. Change font properties to 'inherit' in Safari.
     */

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/**
     * Fix placeholder font properties inheritance.
     */

::-webkit-input-placeholder {
  font: inherit;
}

:-ms-input-placeholder {
  font: inherit;
}

::-ms-input-placeholder {
  font: inherit;
}

::placeholder {
  font: inherit;
}

/**
     * Clickable labels
     */

label[for] {
  cursor: pointer;
}

/* Interactive
       ========================================================================== */

/*
     * Add the correct display in Edge, IE 10+, and Firefox.
     */

details {
  display: block;
}

/*
     * Add the correct display in all browsers.
     */

summary {
  display: list-item;
}

/* Table
       ========================================================================== */

table {
  border-collapse: collapse;
  border-spacing: 0;
}

caption {
  text-align: left;
}

td,
th {
  vertical-align: top;
}

th {
  text-align: left;
  font-weight: ${themeGet('fontWeights.bold')};
}

/* Misc
       ========================================================================== */

/**
     * Add the correct display in IE 10+.
     */

template {
  display: none;
}

/**
     * Add the correct display in IE 10.
     */

[hidden] {
  display: none;
}

/* Input range slider */

.inputSliderContainer {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 34px;
  width: 100%;
  max-width: none;
  padding: 0 0.25rem;
}

@media only screen and (min-width: 658px) {
  .inputSliderContainer {
    max-width: 60%;
    padding: 0;
  }
}

@media only screen and (min-width: 1119px) {
  .inputSliderContainer {
    max-width: 500px;
  }
}

.inputSlider {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 34px;
  margin: 0;
  width: 100%;
  max-width: none;
  padding: 0;
}

.slider-label {
  font-size: 1rem;
  font-weight: normal;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}

@media only screen and (min-width: 658px) {
  .inputSliderContainer {
    max-width: 60%;
    padding: 0;
  }
}

@media only screen and (min-width: 1119px) {
  .inputSliderContainer {
    max-width: 500px;
  }
}

.inputRange {
  height: 1rem;
  position: relative;
  width: 100%;
}

.minLabel,
.maxLabel,
.valueLabel {
  display: none;
}

.sliderValueLabel {
  font-family: inherit;
  line-height: 1.5rem;
  font-size: 0.875rem;
  color: #2b2c32;
  font-weight: 600;
  margin-left: 2rem;
  width: 100%;
  max-width: 100px;
  text-align: right;
  padding: 0 0.25rem 0 0;
  position: absolute;
  right: 0;
  top: -1.5rem;
}

@media only screen and (min-width: 374px) {
  .sliderValueLabel {
    font-size: 1rem;
  }
}

@media only screen and (min-width: 658px) {
  .sliderValueLabel {
    position: relative;
    top: auto;
    right: auto;
    padding: 0;
  }
}

@media only screen and (min-width: 768px) {
  .sliderValueLabel {
    font-size: 1.75rem;
  }
}

.track {
  background: #686868;
  border-radius: 8px;
  cursor: pointer;
  display: block;
  height: 6px;
  position: relative;
  transition:
    left 0.3s ease-out,
    width 0.3s ease-out;
  left: 0;
  margin-top: -0.15rem;
  position: absolute;
  right: 0;
  top: 50%;
}

.activeTrack {
  border-radius: 8px;
  cursor: pointer;
  display: block;
  height: 6px;
  position: relative;
  transition:
    left 0.3s ease-out,
    width 0.3s ease-out;
  left: 0;
  margin-top: -0.2rem;
  position: absolute;
  right: 0;
  top: 50%;
  background: #ee2e24;
}

.sliderContainer {
  transition: left 0.3s ease-out;
}

.slider {
  background: #ee2e24;
  border: 1px solid #ee2e24;
  height: 1.25rem;
  width: 1.25rem;
  appearance: none;
  border-radius: 100%;
  cursor: pointer;
  display: block;
  margin-top: -0.625rem;
  margin-left: -0.625rem;
  position: absolute;
  top: 50%;
  transition:
    transform 0.3s ease-out,
    box-shadow 0.3s ease-out,
    -webkit-transform 0.3s ease-out;
}

@media only screen and (min-width: 768px) {
  .slider {
    height: 1.5rem;
    width: 1.5rem;
    margin-top: -0.75rem;
    margin-left: -0.75rem;
  }
}

.disabledInputRange {
  height: 1rem;
  position: relative;
  width: 100%;
  max-width: 475px;
}

.disabledInputRange .track {
  background: #cccccc;
}

.disabledInputRange .activeTrack {
  background: #cccccc;
}

.disabledInputRange .slider {
  background: #cccccc;
  border: 1px solid #cccccc;
  box-shadow: none;
  transform: none;
}

.velvet {
  .activeTrack {
    background: #80348e;
  }

  .slider {
    background: #80348e;
    border: 1px solid #80348e;
  }

  .sliderValueLabel {
    border-radius: 0.25rem;
    border: 1px solid #d9d9d9;
    padding: 0.35rem !important;
  }
}

div.ot-sdk-row {
  @media only screen and (min-width: 897px) {
    display: flex !important;
  }
}

#onetrust-button-group-parent {
  @media only screen and (min-width: 897px) {
    display: flex !important;
    margin: auto !important;
    justify-content: center;
    position: relative !important; 
    left: unset !important;
    top: unset !important;
    transform: unset !important;
  }
}

#onetrust-button-group {
  display: flex !important;
  flex-direction: column;
  margin: 0 0 1rem !important;
  justify-content: center;
  gap: 1rem;
 
  #onetrust-accept-btn-handler,
  #onetrust-pc-btn-handler {
    margin: 0 !important;
    width: auto !important;
  }

  @media only screen and (min-width: 426px) {
    width: auto !important;
    flex-direction: row;
  }

  @media only screen and (min-width: 897px) {
    flex-direction: column;
    margin: 0 !important;

    #onetrust-accept-btn-handler,
    #onetrust-pc-btn-handler {
      min-width: 205px !important;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    #onetrust-accept-btn-handler,
    #onetrust-pc-btn-handler {
      min-width: 240px !important;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    flex-direction: row;
  }
}

#onetrust-pc-btn-handler {
  order: 2;
}

#onetrust-accept-btn-handler {
  order: 1;
}


${typography}
${bladeStyles}
${toolTipStyles}
${cdicWidgetStyles}
${infoWindowStyles}
${colorStyles}
${variables}
`;

export default GlobalStyles;
